import { Button } from "@/components/ui/button";

interface ProfileInitializationStateProps {
  isLoggingOut: boolean;
  onRetry: () => void;
  onSignOut: () => void;
}

export function ProfileInitializationState({
  isLoggingOut,
  onRetry,
  onSignOut,
}: ProfileInitializationStateProps) {
  if (isLoggingOut) {
    return (
      <div
        className="flex h-screen items-center justify-center bg-background"
        data-testid="logout-transition"
      >
        <div
          className="absolute top-0 left-0 right-0 h-[38px]"
          data-tauri-drag-region
        />
        <img
          src="/ano-mark-white.svg"
          alt="Signing out"
          className="w-24 h-24 object-contain animate-bounce"
        />
      </div>
    );
  }

  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <div
        className="absolute top-0 left-0 right-0 h-[38px]"
        data-tauri-drag-region
      />
      <div className="w-96 space-y-4 text-center">
        <h1 className="text-xl font-semibold text-foreground">
          Could not initialize your profile
        </h1>
        <p className="text-sm text-muted-foreground">
          Please retry or sign out and sign in again.
        </p>
        <div className="flex items-center justify-center gap-2">
          <Button onClick={onRetry}>Retry</Button>
          <Button variant="outline" onClick={onSignOut}>
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
